import React from "react";
import { useState, useEffect } from "react";
import { Input, Radio, Select, Space, Form, Button, notification, message } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import DashboardRequest from "../DashboardRequest";

export const CustomRequestDetails = () => {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const { salonId } = useParams();
  const [fileList, setFileList] = useState([]);
  const [customData, setCustomData] = useState(null);

  useEffect(() => {
    const getCustomDetails = async () => {
      setLoading(true);
      try {
        const res = await DashboardRequest.serviceReqDetail(salonId);
        console.log("res", res)
        const customData = res?.data?.data;


        if (customData) {
          setCustomData(customData);

          form.setFieldsValue({
            categoryName: customData[0]?.saloncategory?.category?.categoryTitle,
            serviceName: customData[0]?.serviceName,
            description: customData[0]?.description,
            actualPrice: customData[0]?.actualPrice,
            sellingPrice: customData[0]?.sellingPrice,
            serviceTime: customData[0]?.serviceTime,
            status: customData[0]?.status === 1 ? "Active" : "Inactive",
            visitType: customData[0]?.visitType,
            maxServiceQuantity: customData[0]?.saloncategory?.maxServiceQuantity,
          });
          console.log(customData[0]?.actualPrice, 'act')

          const imageList = customData[0]?.serviceImage ? [{
            uid: '-1',
            name: 'serviceImage.jpg',
            status: 'done',
            url: customData[0]?.serviceImage,
          }] : [];

          setFileList(imageList);
        }

      } catch (e) {
        console.log(e);

      } finally {
        setLoading(false);
      }
    };

    if (salonId) getCustomDetails();
  }, [salonId, form]);

  console.log("setFileList", setFileList)

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };


  return (
    <>
      <section>
        <div className="Create-Category custom-service">

          <Form.Item className="text-center submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3> Custom Service Request Details</h3>

          {/* Add Ant Design Form component and pass the form instance */}
          <Form
            form={form}
            layout="vertical"
          // onFinish={onFinish}
          >

            <div className="subscription">
              <Form.Item
                name="categoryName"
                label="Category Name"
                className="subscription-plan"
              >
                <Input size="large" />
              </Form.Item>

              <Form.Item
                name="salonName"
                label="Salon Name"
                className="subscription-plan"
              >
                <Input size="large" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="serviceName"
                label="Service Name"
                className="subscription-plan"
              >
                <Input size="large" />
              </Form.Item>

              <Form.Item
                name="status"
                label="Status"
                className="subscription-plan"
              >

                <Input size="large" />
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="visitType"
                label="Visit Type"
                className="subscription-plan"
              >
                <Input size="large" />
              </Form.Item>

              <Form.Item
                name="maxServiceQuantity"
                label="Max Service Quantity"
                className="subscription-plan"
              >
                <Input size="large" />

              </Form.Item>
            </div>
            <div className="subscription">

              <Form.Item
                name="sellingPrice"
                label="Selling Price"
                className="subscription-plan"
              >
                <Input size="large" />
              </Form.Item>
              <Form.Item
                name="actualPrice"
                label="Actual Price"
                className="subscription-plan"
              >
                <Input size="large" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="serviceTime"
                label="Service Duration"
                className="subscription-plan"
              >
                <Input size="large" />
              </Form.Item>
            </div>

          </Form>
        </div>
      </section>
    </>
  );
};
